var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.imgGd}}),_vm._v(" "),_c('span',{staticClass:"site-name"},[_vm._v(_vm._s(this.$i18n.messages[this.$i18n.locale].foot.s1))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b42dee4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/components/LayoutLogo/index.vue
// module id = null
// module chunks = 